import React, { Dispatch, useRef, useEffect, useState } from 'react';
import '../App.css';
import { IInject, IInjectNode, ICOA } from '../interfaces';
import { useXarrow } from 'react-xarrows';
import COADotsDiv from './COADotsDiv';
import { getTranslateXY } from '../helpers/helperFunctions';

interface COADotsProps {
    coaId: number;
    srcNodeId: string;
    setCoaClicked: Dispatch<boolean>;
    coaClicked: boolean;
    injectComponents: IInject[];
    setInjectComponents: Dispatch<IInject[]>;
    injectItem: IInject;
    setInjectItem: Dispatch<IInject>;
    turn: number;
    coa: ICOA;
    saveScenario: (i: IInject[]) => Promise<void>;
    setIsCOADragging: Dispatch<boolean>;
    isCOADragging: boolean;
    nodeHeight: string;
  }

  interface INodeToCheck {
    x: number;
    y: number;
    width: number;
    height: number;
    targetNodeId: string;
    node: HTMLElement;
    srcNodeId: string;
    turn: string;
}

export class NodeToCheck {
    x: number = 0;
    y: number = 0;
    width: number = 0;
    height: number = 0;
    targetNodeId: string = '';
    node: HTMLElement = document.createElement('div');
    srcNodeId: string = '';
    turn: string = '1';
}

interface IIsOver {
    targetNodeId: string;
    isOver: boolean;
}

export class IsOver {
    targetNodeId: string = '';
    isOver: boolean = false;
}

const COADots: React.FC<COADotsProps> = ({ coaId, srcNodeId, setCoaClicked, coaClicked, injectComponents, setInjectComponents, injectItem, setInjectItem, turn, coa, saveScenario, setIsCOADragging, isCOADragging, nodeHeight }) => {

    const [showDeleteCOA, setShowDeleteCOA] = useState<boolean>(false)
    const [toggleDiv, setToggleDiv] = useState<number>(1)
    const [translate, setTranslate] = useState<string>('');
    const [deleteLeft, setDeleteLeft] = useState<string>('');
    const [deleteTop, setDeleteTop] = useState<string>('');

    const showDeleteCOARef = useRef<boolean>()
    useEffect(() => {
        showDeleteCOARef.current = showDeleteCOA;
    });

    const injectItemRef = useRef<IInject>()
    useEffect(() => {
        injectItemRef.current = injectItem;
    });

    const isCOADroppedOverNode = (coaTransform: HTMLElement, srcNodeId: string) => {
        let isOver: boolean = false;
        let nodesToCheck: INodeToCheck[] = []
        let targetNodeId: string = '0';
        let allnodes: HTMLElement[] = []

        const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
        if (nodes !== null) {
            allnodes = Array.from(nodes) as HTMLElement[]
        }

        if (allnodes !== undefined) {
            allnodes.forEach((node: HTMLElement) => {
                let nodeToCheck: INodeToCheck = new NodeToCheck();
                nodeToCheck.x = node.getBoundingClientRect().x
                nodeToCheck.y = node.getBoundingClientRect().y
                nodeToCheck.width = node.getBoundingClientRect().width
                nodeToCheck.height = node.getBoundingClientRect().height
                nodeToCheck.targetNodeId = node.dataset.id!
                nodeToCheck.turn = node.dataset.turn!
                nodeToCheck.node = node
                nodesToCheck.push(nodeToCheck)
            })

            const srcNode = injectItem.nodes.find((n) => n.id === srcNodeId);
            const srcNodeTurn = srcNode?.turn || 1;
            nodesToCheck.forEach((node: INodeToCheck) => {
                if (srcNodeTurn < parseInt(node.turn)) {
                if (coaTransform.getBoundingClientRect().x > node.x && coaTransform.getBoundingClientRect().x < (node.x + node.width)) {
                        if (coaTransform.getBoundingClientRect().y > node.y && coaTransform.getBoundingClientRect().y < (node.y + node.height)) {
                            if (parseInt(node.turn) !== turn) {
                                isOver = true
                                targetNodeId = node.targetNodeId
                                node.node.parentElement!.style.border = ''
                            }
                        }
                    }
                }
            })
        }

        const isOverObj: IIsOver = new IsOver();
        isOverObj.targetNodeId = targetNodeId
        isOverObj.isOver = isOver
        return isOverObj;
    }

    const isCOAOverNode = (coaTransform: HTMLElement, srcNodeId: string): boolean => {
        
        let nodesToCheck: INodeToCheck[] = []
        let allnodes: HTMLElement[] = []
        let isOver: boolean = false;

        const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
        if (nodes !== null) {
            allnodes = Array.from(nodes) as HTMLElement[];
        }

        if (allnodes !== undefined) {
            allnodes.forEach((node: HTMLElement) => {
                let nodeToCheck: INodeToCheck = new NodeToCheck();
                nodeToCheck.x = node.getBoundingClientRect().x
                nodeToCheck.y = node.getBoundingClientRect().y
                nodeToCheck.width = node.getBoundingClientRect().width
                nodeToCheck.height = node.getBoundingClientRect().height
                nodeToCheck.targetNodeId = node.dataset.id!
                nodeToCheck.turn = node.dataset.turn!
                nodeToCheck.node = node
                nodesToCheck.push(nodeToCheck)
            })

            nodesToCheck.forEach((node: INodeToCheck) => {
                if (parseInt(srcNodeId) < parseInt(node.targetNodeId)) {
                    if (coaTransform.getBoundingClientRect().x > node.x && coaTransform.getBoundingClientRect().x < (node.x + node.width)) {
                        if (coaTransform.getBoundingClientRect().y > node.y && coaTransform.getBoundingClientRect().y < (node.y + node.height)) {
                            if (parseInt(node.turn) === turn) {
                                isOver = false;
                                node.node.parentElement!.style.border = ''
                            } else {
                                isOver = true;
                                node.node.parentElement!.style.border = '2px solid #3F83FC'
                            }
                            
                        } else {
                            isOver = false;
                        }
                    }
                }
            })
        }
        
        return isOver;
    }

    const highlightAllNodes = (turnOn: boolean) => {
        let allnodes: HTMLElement[] = []
        const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
        if (nodes !== null) {
            allnodes = Array.from(nodes) as HTMLElement[];

            allnodes.forEach((node: HTMLElement) => {
                if (turn < parseInt(node.dataset.turn!)) {
                    node.parentElement!.style.border = turnOn ? '2px solid #3F83FC' : '';
                }
            });
        }

    }

    const FwdXArrow = () => {
        let clickCoa: HTMLElement = document.querySelector(`#elem${srcNodeId}${coaId}2`)!;
        if (clickCoa !== null) {
            if (!coaClicked) {
                isCOAOverNode(clickCoa, srcNodeId)
            }
        }
        const usexarrow = useXarrow()
        return (usexarrow);
    }

    const useXArrow = FwdXArrow()

    const coaMouseDown = (ev: MouseEvent) => {
        if (coa.nextNodeId !== '') {
            let clickCoa: HTMLElement = document.querySelector(`#elem${srcNodeId}${coaId}2`)!;
            if (clickCoa !== null) {
                setDeleteLeft(getTranslateXY(clickCoa).x + 'px')
                setDeleteTop(getTranslateXY(clickCoa).y + 'px')
            }
            setTimeout(() => {
                setShowDeleteCOA(!showDeleteCOARef.current)
            }, 250)
        } else {
            setCoaClicked(false)
            setTimeout(() => {
                setIsCOADragging(true)
            }, 0)

            window.addEventListener('mouseup', coaMouseUp);
        }
    }

    const coaMouseUp = () => {
        
        let clickCoa: HTMLElement = document.querySelector(`#elem${srcNodeId}${coaId}2`)!;

        if (clickCoa !== null) {
            const isCoaDropped = isCOADroppedOverNode(clickCoa, srcNodeId)
            if (isCoaDropped.isOver) {
                let newNodes: IInjectNode[] = [];

                newNodes = JSON.parse(JSON.stringify(injectItemRef.current!.nodes));

                newNodes.forEach((node: IInjectNode) => {
                    if (srcNodeId === node.id) {
                        node.coas.forEach((coa: ICOA) => {
                            if (coaId === coa.id) {
                                coa.nextNodeId = isCoaDropped.targetNodeId;
                            }
                        })
                    }
                })

                setInjectItem({
                    ...injectItemRef.current!,
                    nodes: newNodes
                });

                setInjectComponents(injectComponents.map((inject: IInject) => {
                    if (inject.id === injectItem.id) {
                        return { ...inject, nodes: newNodes };
                    } else {
                        return inject;
                    }
                }));
                setToggleDiv(toggleDiv+1)
            } else {
                setToggleDiv(toggleDiv+1)
            }
            setCoaClicked(true)
            setIsCOADragging(false)
        }
        window.removeEventListener('mouseup', coaMouseUp);
        setTimeout(() => {
            highlightAllNodes(false);
        }, 250)

    }

    const coa2Click = (ev: MouseEvent) => {
        setDeleteLeft('0')
        setDeleteTop('0')
        setTimeout(() => {
            setShowDeleteCOA(!showDeleteCOARef.current)
        }, 250)
    }

    const coa1MouseDown = (ev: MouseEvent) => {
        setCoaClicked(false)
    }

    const coa1MouseUp = (ev: MouseEvent) => {
        setCoaClicked(true)
    }

    const createListeners = () => {
        
        let clickCoa: HTMLElement = document.querySelector(`#elem${srcNodeId}${coaId}2`)!;

        if (coa.nextNodeId !== '') {
            const clickCoa2: HTMLElement = document.querySelector(`#elem${srcNodeId}${coaId}1`)!;
            const deleteCOA: HTMLElement = document.getElementById(`delete${srcNodeId}${coaId}`)!;
            
            if (clickCoa2 !== null) {
                clickCoa2.removeEventListener('click', coa2Click);
                clickCoa2.addEventListener('click', coa2Click);
                clickCoa2.removeEventListener('mousedown', coa1MouseDown);
                clickCoa2.addEventListener('mousedown', coa1MouseDown);
                clickCoa2.removeEventListener('mouseup', coa1MouseUp);
                clickCoa2.addEventListener('mouseup', coa1MouseUp);
                deleteCOA.removeEventListener('mousedown', coa1MouseDown);
                deleteCOA.addEventListener('mousedown', coa1MouseDown);
                deleteCOA.removeEventListener('mouseup', coa1MouseUp);
                deleteCOA.addEventListener('mouseup', coa1MouseUp);
            }
        }

        if (clickCoa !== null) {
            clickCoa.removeEventListener('mousedown', coaMouseDown);
            clickCoa.addEventListener('mousedown', coaMouseDown);
        }
    }

    useEffect(() => {
        setToggleDiv(toggleDiv+1)
    }, [injectItem.nodes]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setToggleDiv(toggleDiv+1)
    }, [coa.nextNodeId]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        createListeners()
    }, [toggleDiv]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        isCOADragging ? highlightAllNodes(true) : highlightAllNodes(false)
    }, [isCOADragging]) // eslint-disable-line react-hooks/exhaustive-deps

    const deleteLine = async () => {
        let arrowSVG: HTMLElement = document.getElementById(`wrap${srcNodeId}${coaId}1`)!;
        arrowSVG.style.display = 'none'
        let newNodes: IInjectNode[] = [];

        newNodes = JSON.parse(JSON.stringify(injectItemRef.current!.nodes));
        let injectItem1: IInject = JSON.parse(JSON.stringify(injectItem));

        newNodes.forEach((node: IInjectNode) => {
            if (srcNodeId === node.id) {
                node.coas.forEach((coa: ICOA) => {
                    if (coaId === coa.id) {
                        coa.nextNodeId = '';
                    }
                })
            }
        })

        injectItem1.nodes = newNodes

        setShowDeleteCOA(false)


        const injUpdate = injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return injectItem1;
            } else {
                return inject;
            }
        })

        setInjectComponents(injUpdate);
        
        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });

        await saveScenario(injUpdate);
        setToggleDiv(toggleDiv+1);
    }

    return (
        <>
            <COADotsDiv coaId={coaId} srcNodeId={srcNodeId} updateXarrow={useXArrow} coa={coa} key={toggleDiv} showDeleteCOA={showDeleteCOA} deleteLine={deleteLine} nodeHeight={nodeHeight} translate={translate} setTranslate={setTranslate} deleteLeft={deleteLeft} deleteTop={deleteTop} />
        </>
    )
}

export default COADots;